import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function EbookMockup() {
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const rX = useSpring(useTransform(my, [0, 1], [10, -10]), { stiffness: 120, damping: 16 });
  const rY = useSpring(useTransform(mx, [0, 1], [-12, 12]), { stiffness: 120, damping: 16 });

  const onMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    mx.set((e.clientX - rect.left) / rect.width);
    my.set((e.clientY - rect.top) / rect.height);
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={() => { mx.set(0.5); my.set(0.5); }}
      className="relative [perspective:1200px] w-[280px] sm:w-[340px] lg:w-[380px] mx-auto"
      data-testid="ebook-mockup"
    >
      <motion.div
        style={{ rotateX: rX, rotateY: rY, transformStyle: "preserve-3d" }}
        className="relative float-slow"
      >
        {/* spine */}
        <div className="absolute left-0 top-[2%] bottom-[2%] w-[14px] -translate-x-[13px] rounded-l-md bg-[#12261A] shadow-inner" />
        {/* pages */}
        <div className="absolute right-0 top-[2.5%] bottom-[2.5%] w-[10px] translate-x-[9px] rounded-r-sm bg-[repeating-linear-gradient(90deg,#fff_0px,#fff_2px,#e8e2d5_3px)]" />
        {/* cover */}
        <div className="relative aspect-[3/4.2] rounded-r-lg rounded-l-sm overflow-hidden shadow-[0_40px_80px_-20px_rgba(18,38,26,0.55)] ring-1 ring-[#D4A359]/40">
          <img
            src="/ebook-cover.jpg"
            alt="The Sustainable Tea & Weight Loss Method — ebook cover"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-white/15 pointer-events-none" />
        </div>
        {/* price badge */}
        <motion.div
          initial={{ scale: 0, rotate: -20 }}
          animate={{ scale: 1, rotate: 8 }}
          transition={{ delay: 1.1, type: "spring", stiffness: 200, damping: 12 }}
          className="absolute -right-6 -top-6 w-24 h-24 rounded-full bg-[#D4A359] text-[#12261A] flex flex-col items-center justify-center shadow-xl ring-4 ring-[#FAF7F2] rotate-2"
          data-testid="price-badge"
        >
          <span className="font-display text-2xl font-bold leading-none">$22</span>
          <span className="text-[8px] font-extrabold tracking-[0.14em] uppercase mt-0.5">Digital Edition</span>
        </motion.div>
      </motion.div>
    </div>
  );
}
